// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2h7gd","colBig":"styles_colBig__27ZLl","colSmall":"styles_colSmall__-dlfi"};